import createReducer from '../../utils/createReducer'
import * as actions from './actions'
import { CoreUxOrderStatus } from 'src/componentsV2/CoreUX/types/coreUxOrder.types'
import { Cutoff } from './actions'

export interface MetadataState {
  date: string | null
  orderStatus: CoreUxOrderStatus | null
  displayDate: string | null
  cutoff: Cutoff | null
}

const initialState: MetadataState = {
  date: null,
  orderStatus: null,
  displayDate: null,
  cutoff: null
}

export default createReducer(initialState, {
  [actions.updateMetadata]: (_, { payload }) => payload,
  [actions.updateOrderStatus]: (state, { payload }) => ({
    ...state,
    orderStatus: payload
  }),
  [actions.resetMetadata]: () => initialState
})
